import { useStore } from '@tanstack/react-form';
import { use, useEffect } from 'react';

import DirtyHandlerContext from '../../../contexts/DirtyHandlerContext';

import { useFormContext } from '../../form';

interface DirtyHandlerProps {
  dirty?: boolean;
  allowLeaveWhenSubmitting?: boolean;
}

const DirtyHandler = ({
  dirty,
  allowLeaveWhenSubmitting,
}: DirtyHandlerProps) => {
  const form = useFormContext();

  const { isDirty, isSubmitting, isTouched } = useStore(
    form.store,
    (state) => ({
      isDirty: state.isDirty,
      isSubmitting: state.isSubmitting,
      isTouched: state.isTouched,
    }),
  );

  const { setDirty, setSubmitting } = use(DirtyHandlerContext);

  useEffect(() => {
    setDirty(dirty || (isDirty && !isSubmitting && isTouched));
    return () => {
      setDirty(false);
    };
  }, [dirty, isDirty, isSubmitting, isTouched, setDirty]);

  useEffect(() => {
    if (allowLeaveWhenSubmitting) return;
    setSubmitting(isSubmitting);
    return () => {
      setSubmitting(false);
    };
  }, [isSubmitting, setSubmitting, allowLeaveWhenSubmitting]);

  return null;
};

export default DirtyHandler;
